@import "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&family=Roboto+Condensed:wght@400;500;600;700&display=swap";

/* src/app/core/pages/privacy/privacy.page.scss */
:root {
  --poppins-font: "Poppins", sans-serif;
  --roboto-font: "Roboto Condensed", sans-serif;
}
.heading-title {
  font-size: 22px;
  color: #fff;
  font-family: var(--poppins-font);
  font-weight: 600;
}
.descriptions {
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  font-family: var(--roboto-font);
  color: #444444 !important;
  text-align: justify !important;
}
.page-title {
  font-size: 28px;
  font-family: var(--poppins-font);
  font-weight: 700;
  line-height: 42px;
  color: #417432;
}
.page-subtitle {
  font-size: 22px;
  font-family: var(--poppins-font);
  font-weight: 600;
  line-height: 32px;
  color: #1d1b1b;
}
/*# sourceMappingURL=privacy.page.css.map */
